/**
 * ? @description : MUI Snackbar
 */

// Dependencies
import React from "react";
import { Snackbar, Alert, Slide } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";

// Redux Component
import { hideSnackbar } from "../redux/features/appSlice";

function SnackbarMessage() {
  const dispatch = useDispatch();
  const { snackbar } = useSelector((state) => state.app.value);

  // * Close Snackbar Function
  const handleSnackbarClose = () => {
    dispatch(hideSnackbar());
  };

  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={5000}
      onClose={handleSnackbarClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      TransitionComponent={Slide}
    >
      <Alert
        onClose={handleSnackbarClose}
        severity={snackbar.severity}
        variant="standard"
        sx={{ zIndex: 500, width: "100%" }}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
}

export default SnackbarMessage;
